/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/flipCard.scss';

import classNames from 'classnames';

import React from 'react';

interface Props {
    className?: string;
    children: [React.ReactElement, React.ReactElement];
    flip: boolean;
}

export default function FlipCard(props: Props) {
    const {flip, className, children} = props;
    return (
        <div className={classNames('flip-card', className)}>
            <div className={classNames('flip-card-inner', flip && 'flip')}>
                <div className='card-side'>{children[0]}</div>
                <div className='card-side back'>{children[1]}</div>
            </div>
        </div>
    );
}
